import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import ModalContentBase from "../modal_content_base";
import ModalMyCircle from "./my_circle";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    myCircles: PropTypes.array.isRequired,
    myManagingCircles: PropTypes.array.isRequired,
    isWebViewTabApp: PropTypes.bool.isRequired,
  },
  render() {
    const myCircles = this.props.myCircles.map(
      function(myCircle) {
        if (myCircle.circle && myCircle.manager_status == 1) {
          return <ModalMyCircle myCircle={myCircle} key={myCircle.id} />;
        }
      }.bind(this)
    );
    let bottom = null;
    if (this.props.isWebViewTabApp) {
      bottom = "-20px";
    }
    var previewContent = null;
    var modalContent = null;
    if (this.props.myManagingCircles.length > 0) {
      previewContent = (
        <div className="right-bottom-suggest-button" style={{ bottom: bottom }}>
          <p className="mb0 bold" style={{ lineHeight: "1.2" }}>
            <small>イベント</small>
          </p>
          <p className="font-size-30">
            <i className="fas fa-calendar-alt" />
          </p>
        </div>
      );

      modalContent = (
        <div>
          <div className="modal-view-header">
            <p
              className="bold"
              style={{
                margin: "10px 0 0",
                padding: "0 20px",
                textAlign: "left",
                fontSize: "26px",
              }}
            >
              イベントつくる？
            </p>
          </div>
          <div
            className="modal-view-body"
            style={{ padding: "10px 25px 0", textAlign: "left" }}
          >
            {myCircles}
          </div>
          <div className="modal-view-footer" style={{ padding: "20px" }} />
        </div>
      );
    } else {
      previewContent = (
        <div className="right-bottom-suggest-button" style={{ bottom: bottom }}>
          <p className="mb0 bold" style={{ lineHeight: "1.2" }}>
            <small>サークル</small>
          </p>
          <p className="font-size-30">
            <i className="fas fa-users" />
          </p>
        </div>
      );

      modalContent = (
        <div>
          <div className="modal-view-header">
            <p
              className="center bold"
              style={{
                margin: "10px 0 0",
                padding: "0 20px",
                fontSize: "28px",
              }}
            >
              サークルつくろう！
            </p>
          </div>
          <div
            className="modal-view-body"
            style={{ padding: "30px 25px 10px" }}
          >
            <a
              href="/circle_new"
              className="btn btn-info"
              style={{ width: "100%" }}
            >
              <p>サークルをつくる</p>
            </a>
          </div>
          <div className="modal-view-footer" style={{ padding: "20px" }} />
        </div>
      );
    }

    return (
      <ModalContentBase
        previewContent={previewContent}
        modalContent={modalContent}
      />
    );
  },
});
